<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.messages', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <div class="sm:col-span-3">
                    <div class="">
                        <FormLabel :value="$tc('messages.teachers', 1)" for="teacher_id" />
                        <FormSelect
                            id="teacher_id"
                            v-model="form.teacher_id"
                            :options="options.teachers"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.teacher_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1 flex space-x-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.date') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.messages', 1) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.sender') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.recipient') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(message, index) in messages.data"
                                :key="message.id"
                            >
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <span> {{ message.date_display }}</span>
                                </td>
                                <td class="px-6 py-4 max-w-md whitespace-pre-line text-sm leading-5 text-gray-500">
                                    <p v-html="message.message" />
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <span :title="message.sender.full_name">
                                        {{ message.sender.name_or_nickname }}
                                    </span>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <div v-if="message.batch">
                                        <inertia-link
                                            :href="message.links.message_batch_show"
                                            :title="$t('messages.group_message')"
                                            v-if="message.batch"
                                        >
                                            <IconSpeakerphone class="w-4 h-4 text-indigo-600" />
                                        </inertia-link>
                                    </div>
                                    <div v-else>
                                        <span :title="message.recipient.full_name">
                                            {{ message.recipient.name_or_nickname }}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="messages" />
        </template>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import { IconSpeakerphone } from '@tabler/icons-vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        FormError,
        FormSelect,
        FormLabel,
        PanelPage,
        InertiaPagination,
        IconSpeakerphone,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'messages', 'options', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
                teacher_id: this.filters.teacher_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
